const DAY_MS = 86400000;
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const parseIso = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return Date.UTC(y, m - 1, d);
};

export const toIso = (ms) => new Date(ms).toISOString().slice(0, 10);

export const todayIso = (now = new Date()) =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

export const formatShortDate = (iso) => {
  const [, m, d] = iso.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}`;
};

export const formatLongDate = (iso) => `${formatShortDate(iso)}, ${iso.slice(0, 4)}`;

export const quarterOf = (now = new Date()) => ({
  year: now.getFullYear(),
  quarter: Math.floor(now.getMonth() / 3) + 1,
});

export const quarterBounds = (year, quarter) => ({
  start_date: toIso(Date.UTC(year, (quarter - 1) * 3, 1)),
  end_date: toIso(Date.UTC(year, quarter * 3, 0)),
});

export const computeGoalStats = ({ goalCount, startCount, startDate, endDate, currentCount, today }) => {
  const remaining = Math.max(goalCount - currentCount, 0);
  const added = Math.max(currentCount - startCount, 0);
  const span = goalCount - startCount;
  const pctOfWay = span > 0 ? Math.min(Math.max(added / span, 0), 1) * 100 : 0;
  const daysLeft = Math.max(Math.round((parseIso(endDate) - parseIso(today)) / DAY_MS), 0);
  const neededPerWeek = daysLeft > 0 ? Math.ceil(remaining / (daysLeft / 7)) : remaining;
  return {
    remaining,
    added,
    pctOfWay,
    daysLeft,
    neededPerWeek,
    goalReached: currentCount >= goalCount,
    totalSpan: span,
    startDate,
    endDate,
  };
};

export const buildChartData = ({ startDate, endDate, startCount, goalCount, points }) => {
  const startMs = parseIso(startDate);
  const endMs = parseIso(endDate);
  const span = endMs - startMs;
  const actualByMs = new Map(points.map((p) => [parseIso(p.date), p.count]));
  const times = new Set([startMs, endMs, ...actualByMs.keys()]);
  return [...times]
    .sort((a, b) => a - b)
    .map((ms) => ({
      time: ms,
      actual: actualByMs.has(ms) ? actualByMs.get(ms) : null,
      pace: Math.round(startCount + ((goalCount - startCount) * (ms - startMs)) / span),
    }));
};

export const monthTicks = (startDate, endDate) => {
  const startMs = parseIso(startDate);
  const endMs = parseIso(endDate);
  const ticks = [startMs];
  const start = new Date(startMs);
  let cursor = Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 1);
  while (cursor < endMs) {
    ticks.push(cursor);
    const d = new Date(cursor);
    cursor = Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1);
  }
  return ticks;
};
